var _style, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMotionIcon04(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "listos",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M50,0C22.4,0,0,22.4,0,50c0,0.6,0,1.3,0,1.9C0.2,56,0.8,60,1.9,63.8C7.4,82.8,23.9,97.2,44,99.6 c2,0.2,4,0.4,6,0.4c2,0,4-0.1,6-0.4c20.2-2.4,36.6-16.8,42.1-35.9c1.1-3.8,1.7-7.8,1.9-11.9c0-0.6,0-1.3,0-1.9C100,22.4,77.6,0,50,0 z M44,91.6C27.9,89.2,14.7,77.7,9.9,62.5l26.4-4.2c1.8,2.9,4.5,5.3,7.7,6.6V91.6z M54.3,56.8C53,57.5,51.6,58,50,58s-3-0.5-4.3-1.2 c-0.6-0.4-1.2-0.9-1.7-1.5c-1.2-1.4-2-3.3-2-5.3c0-1.9,0.7-3.7,1.8-5.1c0-0.1,0.1-0.1,0.2-0.2c0.2-0.3,0.5-0.5,0.7-0.7 c1.4-1.2,3.3-2,5.3-2c2,0,3.9,0.8,5.3,2c0.3,0.2,0.5,0.5,0.7,0.7c0,0.1,0.1,0.1,0.2,0.2c1.1,1.4,1.8,3.2,1.8,5.1c0,2-0.8,3.9-2,5.3 C55.5,55.9,54.9,56.4,54.3,56.8z M56,91.6V64.8c3.2-1.3,5.9-3.6,7.7-6.6l26.4,4.2C85.4,77.7,72.2,89.2,56,91.6z M92,50.6l-26.4-4.2 C64,39.3,57.6,34,50,34s-14,5.3-15.6,12.4L8,50.6c0-0.2,0-0.4,0-0.6C8,26.8,26.8,8,50,8c23.2,0,42,18.8,42,42 C92,50.2,92,50.4,92,50.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMotionIcon04);
export default __webpack_public_path__ + "static/media/motion_icon-04.94794718.svg";
export { ForwardRef as ReactComponent };